import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { ArrowRight } from "lucide-react";
import { cn } from "../../../utils";
function renderIcon(icon) {
    if (!icon) return null;
    if (/*#__PURE__*/ React.isValidElement(icon)) return icon;
    const Icon = icon;
    return /*#__PURE__*/ _jsx(Icon, {
        className: "h-4 w-4 shrink-0"
    });
}
export function DialogShellNav({ sections, width, activeStyle = "card", className, "aria-label": ariaLabel }) {
    const isFluid = width === undefined;
    return /*#__PURE__*/ _jsx("nav", {
        "aria-label": ariaLabel,
        className: cn("flex flex-col gap-3", isFluid ? "w-full" : "shrink-0", className),
        style: isFluid ? undefined : {
            width
        },
        children: sections.map((section, sectionIndex)=>/*#__PURE__*/ _jsxs(React.Fragment, {
                children: [
                    sectionIndex > 0 && /*#__PURE__*/ _jsx("div", {
                        className: "border-t",
                        role: "separator"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: cn("flex flex-col gap-1", sectionIndex > 0 && "pt-3"),
                        children: [
                            section.heading && /*#__PURE__*/ _jsx("p", {
                                className: "text-2xs font-semibold uppercase tracking-wider text-muted-foreground px-2 pt-1",
                                children: section.heading
                            }),
                            section.items.map((item)=>/*#__PURE__*/ _jsx(NavRow, {
                                    item: item,
                                    activeStyle: activeStyle
                                }, item.id))
                        ]
                    })
                ]
            }, section.id))
    });
}
function NavRow({ item, activeStyle }) {
    const { active, onSelect, label, count, trailing, indent, icon } = item;
    const cardActive = "border border-bliks-green-500/40 bg-white text-foreground font-semibold shadow-[0_1px_0_rgba(0,0,0,0.03)]";
    const cardInactive = "border border-transparent hover:bg-accent text-foreground";
    const flatActive = "bg-primary/10 text-primary font-medium";
    const flatInactive = "hover:bg-accent text-foreground";
    const stateClass = active ? activeStyle === "card" ? cardActive : flatActive : activeStyle === "card" ? cardInactive : flatInactive;
    const showCardChevron = activeStyle === "card" && active && trailing === undefined;
    return /*#__PURE__*/ _jsxs("button", {
        type: "button",
        onClick: onSelect,
        "aria-current": active ? "true" : undefined,
        className: cn("flex items-center gap-2 rounded-md px-2 py-2 text-sm text-left outline-hidden transition-colors focus-visible:ring-3 focus-visible:ring-ring/50", stateClass),
        style: indent ? {
            paddingLeft: `${8 + indent}px`
        } : undefined,
        children: [
            renderIcon(icon),
            /*#__PURE__*/ _jsx("span", {
                className: "flex-1 min-w-0 truncate",
                children: label
            }),
            count !== undefined && /*#__PURE__*/ _jsx("span", {
                className: "shrink-0 text-xs text-muted-foreground tabular-nums",
                children: count
            }),
            trailing,
            showCardChevron && /*#__PURE__*/ _jsx(ArrowRight, {
                className: "h-4 w-4 shrink-0"
            })
        ]
    });
}

//# sourceMappingURL=DialogShellNav.js.map